module.exports = __webpack_public_path__ + "img/travelling-thali-desktop_and_mobile.f04fe5cb.jpg";